module.exports = __webpack_public_path__ + "img/crown@2x.31108b9.webp";